/**
 scripts for protocol adherence - processing csv upload of LEI
 */

import React from 'react';
import ReactDom from 'react-dom';

import { Preview_Adherence } from './preview-adherence';
import uploadAdherenceLogo from './protocol-adherence-logo';
import './protocol-adherence-annex-id-check';
import './protocol-adherence-validate-lei';
import BulkUploadLetters from './bulk-upload-letters';

(function( $ ) {
		'use strict';
		var previewAdherence = new Preview_Adherence();

		$( document ).ready( function() {

			$( '#logo-file' ).on( 'change', function( event ) {
				event.preventDefault();
				uploadAdherenceLogo();
			} );

			/**
			 * Protocol select, redirect to other protocol
			 */
			$( '.select-protocol' ).change( function( event ) {
				window.location.href = event.target.value;
			} );

			$( '.btn-preview-adh-letter' ).click( function( e ) {
				let formData = $( '#protocols-adherence-letter-form' )
					.serialize();
				previewAdherence.savePostData( formData );
			} );

			$( '#protocols-adherence-letter-form' ).validator()
			                                       .on( 'submit', function( e ) {
				                                       if ( !e.isDefaultPrevented() ) {
					                                       $( '[type=submit], .btn-preview-adh-letter', this )
						                                       .attr( 'disabled', 'disabled' )
						                                       .addClass( 'disabled' );
					                                       $( '[type=submit]', this )
						                                       .html( ' <img class="spinner" src="' + ISDA_Main.ajaxLoader + '">' );
				                                       }

			                                       } );

		} );
	}
)( jQuery );

var BulkLettersElement = document.getElementById( 'bulk-upload-letters-element' );
if ( BulkLettersElement ) {
	ReactDom.render( <BulkUploadLetters />, BulkLettersElement );
}
